import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PortalType } from '../../domain/portal';
import { OtpRequest } from '../../domain/qualification';
import { getPortalType, isEmbedded } from '../../utils';

type PortalState = {
  portalType: PortalType;
  selectedChannel: OtpRequest['channel'] | null;
  isEmbedded: boolean;
};

const initialState: PortalState = {
  portalType: getPortalType(),
  selectedChannel: null,
  isEmbedded: isEmbedded(),
};

const slice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    setSelectedChannel: (state, { payload }: PayloadAction<OtpRequest['channel']>) => {
      state.selectedChannel = payload;
    },
  },
});

export const portalReducer = slice.reducer;

export const { setSelectedChannel } = slice.actions;
